export default "__VITE_ASSET__CEqdRLag__"